var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgVerification = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.352 13.19-1.341-1.005a1.662 1.662 0 0 1-.518-1.92l.64-1.554a1.655 1.655 0 0 0-1.31-2.253l-1.678-.213a1.619 1.619 0 0 1-1.402-1.402l-.214-1.676a1.657 1.657 0 0 0-2.255-1.31l-1.556.64a1.665 1.665 0 0 1-1.92-.517L15.76.64c-.64-.853-1.95-.853-2.591 0l-.977 1.37a1.665 1.665 0 0 1-1.92.518l-1.555-.67a1.657 1.657 0 0 0-2.255 1.31L6.25 4.845a1.62 1.62 0 0 1-1.403 1.402L3.17 6.46a1.656 1.656 0 0 0-1.311 2.254l.64 1.554c.274.67.061 1.462-.518 1.92L.641 13.22c-.854.64-.854 1.95 0 2.59l1.37 1.005c.579.457.793 1.25.518 1.92l-.67 1.553a1.655 1.655 0 0 0 1.31 2.253l1.678.213c.73.092 1.31.67 1.403 1.402l.213 1.676a1.657 1.657 0 0 0 2.255 1.31l1.556-.64a1.667 1.667 0 0 1 1.92.517l1.037 1.34c.64.853 1.95.853 2.591 0l1.036-1.34a1.665 1.665 0 0 1 1.921-.517l1.556.64a1.657 1.657 0 0 0 2.255-1.31l.213-1.676a1.62 1.62 0 0 1 1.403-1.402l1.677-.213a1.656 1.656 0 0 0 1.311-2.253l-.64-1.555a1.664 1.664 0 0 1 .518-1.919l1.34-1.035c.794-.64.794-1.92-.06-2.59z",
    fill: "#57C480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.744 18.472a1.562 1.562 0 0 1-1.18.528 1.56 1.56 0 0 1-1.18-.528l-2.905-3.205c-.639-.704-.639-1.867 0-2.57a1.549 1.549 0 0 1 2.33 0l1.722 1.9 4.66-5.069a1.549 1.549 0 0 1 2.33 0c.639.704.639 1.867 0 2.571l-5.777 6.373z",
    fill: "#FFF"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVerification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/verification.06e2536d.svg";
export { ForwardRef as ReactComponent };